var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEncrypt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646",
    transform: "translate(-415 -2944)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(415 2944)",
    fill: "rgba(255,238,0,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "application-pgp-encrypted-svgrepo-com",
    d: "M24.811,11.234a1.435,1.435,0,0,0-1.436,1.444V36.29a1.435,1.435,0,0,0,1.436,1.444h17.53a1.435,1.435,0,0,0,1.436-1.444V18.548H38.5a1.938,1.938,0,0,1-2.024-1.836V11.234H24.811Zm12.665,0v5.477a.93.93,0,0,0,1.02.832h5.281l-6.3-6.309Zm-3.9,8.639a3.87,3.87,0,0,1,3.861,3.861v2.291A1.875,1.875,0,0,1,38.9,27.862v4.4a1.873,1.873,0,0,1-1.875,1.883H30.123a1.879,1.879,0,0,1-1.883-1.883v-4.4a1.875,1.875,0,0,1,1.475-1.836V23.735A3.87,3.87,0,0,1,33.576,19.874Zm0,1.287A2.564,2.564,0,0,0,31,23.735v2.252H36.15V23.735A2.564,2.564,0,0,0,33.576,21.161Z",
    transform: "translate(405.424 2943.516)",
    fill: "#b7ae39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncrypt);
export default __webpack_public_path__ + "static/media/encrypt.73b534bf4d9aa40bbbbc2eee53fa96c9.svg";
export { ForwardRef as ReactComponent };